<div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeTransactionModal()"
                aria-label="Close"></button>
        </div>
        <div class="modal-body ">
            <div class="bg-grey-option">
                <div class="transact-view">
                    <div class="walletaddress_tooltip" id="tooltip-head">
                        <h2>Contract call to {{transactionModalData.contractAddress}}.
                            <span class="cursor-pointer mx-2"><img src="assets/images/copy-wallet.svg" alt="copy"
                                    (click)="copyAddress(transactionModalData.contractAddress)">
                            </span>
                        </h2>
                    </div>
                </div>
                <div class="transact-card-details">
                    <h3>{{transactionModalData.operationName | uiTerminology}}.</h3>
                    <div class="d-flex align-items-center justify-content-between mb-8">
                        <div class="d-flex align-items-center w-65">
                            <h5 class="approve" *ngIf="transactionModalData.operationStatus === 0">In Progress.</h5>
                            <em class="bi bi-info-circle-fill approve"
                                *ngIf="transactionModalData.operationStatus === 0"></em>

                            <h5 class="success" *ngIf="transactionModalData.operationStatus === 1">Success.</h5>
                            <em class="bi bi-info-circle-fill success"
                                *ngIf="transactionModalData.operationStatus === 1"></em>

                            <h5 class="in_balance" *ngIf="transactionModalData.operationStatus === 2">
                                {{transactionModalData.errorMessage}}.</h5>
                            <em class="bi bi-info-circle-fill in_balance"
                                *ngIf="transactionModalData.operationStatus === 2"></em>
                        </div>
                        <div>
                            <h6>{{transactionModalData.transactionTime | readableDate}}.</h6>
                        </div>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="0"
                        aria-valuemin="0" aria-valuemax="100" *ngIf="transactionModalData.operationStatus === 0">
                        <div class="progress-bar approve" style="width: 30%"></div>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="0"
                        aria-valuemin="0" aria-valuemax="100" *ngIf="transactionModalData.operationStatus === 1">
                        <div class="progress-bar success" style="width: 100%"></div>
                    </div>
                    <div class="user-detail">
                        <div class="w-100">
                            <h5>Interacted with (to).</h5>
                            <h6>{{transactionModalData.contractAddress}}.
                                <span class="cursor-pointer mx-2"><img src="assets/images/copy-wallet.svg" alt="copy"
                                        (click)="copyAddress(transactionModalData.contractAddress)">
                                </span>
                            </h6>
                        </div>
                        <div *ngIf="transactionModalData.transactionHash">
                            <h5>Tx hash.</h5>
                            <div class="d-flex align-items-center gap-2">
                                <p>{{transactionModalData.transactionHash.slice(0,
                                    8)}}...{{transactionModalData.transactionHash.slice(transactionModalData.transactionHash.length
                                    - 7)}}.</p>
                                <a target="_blank" href="{{transhUrl}}/tx/{{transactionModalData.transactionHash}}"
                                    rel="noopener">
                                    <img src="assets/images/transacation-external.svg" alt="" width="18"
                                        height="18"></a>
                            </div>
                        </div>
                    </div>
                    <div class="nftitems">
                        <ng-container *ngFor="let nft of transactionModalData.nfts; let nftIndex = index">
                            <div *ngIf="nft?.fileType !== 'html'"
                                [ngClass]="{'transaction active': transactionModalData.activeNft?._id === nft._id}"
                                (click)="setActiveNft(nftIndex)">
                                <img [src]="(nft?.preview_image ? nft?.preview_image : nft.primary_media) | pinataThumbnail: 88" alt="img"
                                    width="46" height="46" appImageFallback
                                    (load)="imageLoading = false">
                            </div>
                            <div *ngIf="nft?.fileType === 'html'" class="gemview-transacation"
                                [ngClass]="{'active': transactionModalData.activeNft?._id === nft._id}"
                                (click)="setActiveNft(nftIndex)">
                                <img [src]="(nft?.preview_image ? nft?.preview_image : nft.secondary_media[0]) | pinataThumbnail: 88"
                                    width="46" height="46" alt="nft"
                                    [ngClass]="{'active': transactionModalData.activeNft?._id === nft._id}"
                                    (click)="setActiveNft(nftIndex)" appImageFallback
                                    (load)="imageLoading = false">
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="more-details">
                <div class="d-flex align-items-start justify-content-between flex-wrap">
                    <h3>More details.</h3>
                </div>
                <!-- Dropped for a call that has no asset behind it — the deposit fee is paid
                     before anything is minted — rather than shown as an empty name linking to
                     an asset page that does not exist. -->
                <div class="asset-details" *ngIf="transactionModalData.activeNft?._id">
                    <div class="first">
                        <h3>Asset.</h3>
                    </div>
                    <div class="second">
                        <h4>{{transactionModalData.activeNft?.name}}.</h4>
                        <a [routerLink]="['/nft-detail', transactionModalData.activeNft?.collections?.collection_address, transactionModalData.activeNft?.token_id]" target="_blank"><img
                                src="assets/images/transacation-external.svg" alt="arrow"></a>
                    </div>
                </div>
                <div class="asset-details">
                    <div class="first">
                        <h3>Block number.</h3>
                    </div>
                    <div class="second">
                        <h4>{{txDetails.blockNumber}}.</h4>
                    </div>
                </div>
                <div class="asset-details">
                    <div class="first">
                        <h3>Gas price.</h3>
                    </div>
                    <div class="second">
                        <h4>{{txDetails.gasPrice}} POL.</h4>
                    </div>
                </div>
                <div class="asset-details">
                    <div class="first">
                        <h3>Last update.</h3>
                    </div>
                    <div class="second">
                        <h4>{{transactionModalData.transactionTime | readableDate}}.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end-->
